import React from "react";
import styled from "styled-components";

const Counter = styled.div`
  display: inline-grid;
  grid-template-columns: 34px minmax(42px, auto) 34px;
  align-items: center;
  min-height: 36px;
  padding: 3px;
  border: 1px solid #e8e4e2;
  border-radius: 999px;
  background: #f8f7f6;
  box-shadow: none;

  &:focus-within {
    border-color: #ee754c;
    box-shadow: 0 0 0 3px rgba(238, 117, 76, 0.13);
  }
`;

const CounterButton = styled.button`
  width: 30px;
  height: 30px;
  min-height: 30px;
  justify-self: center;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #ee754c;
  font-size: 0.95rem;
  font-weight: 750;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.16s ease, color 0.16s ease;

  &:hover:not(:disabled) {
    background: #ffffff;
    box-shadow: 0 2px 8px rgba(42, 31, 33, 0.08);
  }

  &:disabled {
    color: #c9c1bf;
    cursor: default;
  }
`;

const CounterValue = styled.input`
  width: 100%;
  min-width: 42px;
  padding: 5px 3px;
  border: 0;
  outline: none;
  background: transparent;
  color: #33282a;
  font-size: 0.85rem;
  font-weight: 750;
  text-align: center;
  appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    margin: 0;
    appearance: none;
  }
`;

export const StepperRuleGroup = styled.div`
  display: grid;
  gap: 10px;
  padding: 14px;
  border: 1px solid #ece5e2;
  border-radius: 11px;
  background: #fcfaf9;
`;

export const StepperRule = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #5f5456;
  font-size: 0.88rem;
  font-weight: 700;
`;

const NumberStepper = ({
  value,
  onChange,
  min = 0,
  max = 999,
  step = 1,
  disabled = false,
  displayEmpty = false,
  decreaseLabel = "Decrease",
  increaseLabel = "Increase",
}) => {
  const normalized = Number.isFinite(Number(value)) ? Number(value) : min;

  const setValue = (nextValue) => {
    if (disabled) return;
    onChange(Math.min(max, Math.max(min, Number(nextValue) || 0)));
  };

  return (
    <Counter>
      <CounterButton
        type="button"
        onClick={() => setValue(normalized - step)}
        disabled={disabled || normalized <= min}
        aria-label={decreaseLabel}
      >
        −
      </CounterButton>

      <CounterValue
        type="number"
        min={min}
        max={max}
        step={step}
        value={displayEmpty ? "" : normalized}
        readOnly={disabled}
        aria-disabled={disabled}
        onChange={(event) => setValue(event.target.value)}
      />

      <CounterButton
        type="button"
        onClick={() => setValue(normalized + step)}
        disabled={disabled || normalized >= max}
        aria-label={increaseLabel}
      >
        +
      </CounterButton>
    </Counter>
  );
};

export default NumberStepper;
